import React from 'react';
import './About.css';

import { Link } from 'react-router-dom';
import AboutUsSectionImg from '../../utils/images/history.jpg';
import ChooseSection from '../../components/ChooseSection/ChooseSection';
import Person1 from '../../utils/images/person1.jpg';
import Person2 from '../../utils/images/person2.jpg';
import Person3 from '../../utils/images/person3.jpg';
import Person4 from '../../utils/images/person4.jpg';
import Person5 from '../../utils/images/person5.jpg';
import Person6 from '../../utils/images/person6.jpg';
import Person7 from '../../utils/images/person7.jpg';
import Person8 from '../../utils/images/person8.jpg';
import Person9 from '../../utils/images/person9.jpg';


const persons = [
    {
        id: 1,
        img: [Person1]
    },
    {
        id: 2,
        img: [Person2]
    },
    {
        id: 3,
        img: [Person3]
    },
    {
        id: 4,
        img: [Person4]
    },
    {
        id: 5,
        img: [Person5]
    },
    {
        id: 6,
        img: [Person6]
    },
    {
        id: 7,
        img: [Person7]
    },
    {
        id: 8,
        img: [Person8]
    },
    {
        id: 9,
        img: [Person9]
    },
  
];

const ContactUsPage = () => {
    // Contact Information
    const postalAddress = `Quaid-e-Awam University of Engineering, Science & Technology, Nawabshah 67480, Sindh - Pakistan.`;
    const phone1 = '92-244-9370381-5';
    const phone2 = '92-244-9370367';
    const email = 'registrar@quest.edu.pk';
   
  return (
    <div className='about-page'>
        <header className='height-60'>
            <div className='container h-100 d-flex flex-column align-items-center justify-content-center text-light'>
                <h1 className='text-center fw-semibold'>About Us</h1>
                <p className='text-center w-10 mb-8' style={{ fontSize: '12px' }}>
  Welcome to QUEST, where academic excellence meets transformative learning. Established in 1963 our university is committed to nurturing inquisitive minds, fostering innovation, and empowering students to achieve their aspirations. With a rich history of producing leaders and changemakers, we take pride in our tradition of academic rigor combined with a forward-thinking approach to education.
</p>
<p className='text-center w-10 mb-8' style={{ fontSize: '12px' }}>
  At QUEST, we offer a diverse range of programs across disciplines, tailored to prepare students for the challenges of a rapidly evolving world. Our dedicated faculty, state-of-the-art facilities, and vibrant campus life create an environment that inspires intellectual curiosity, personal growth, and community engagement. Guided by our core values of integrity, inclusivity, and excellence, we strive to shape not just professionals but responsible global citizens. Join us on this journey of discovery and achievement as we work together to shape a brighter future for all.
</p>

            </div>
        </header>

        <div className='container my-5'>
            <div className="row">
                <div className='col-lg-6 d-flex flex-column justify-content-center mb-4 mb-lg-0'>
                  <p className='mb-4 mb-lg-5'style={{ color: 'black' }}><strong>Contact us</strong></p>
                    <p style={{ color: 'black' }}>For all other inquiries, please complete the form in our Feedback section with your comments or questions, and a University's representative will be in contact with you.</p>
                    <div className='container my-5'>
        <div className="row">
          <div className="col-lg-12">
            
            <p style={{ color: 'black' }}><strong>Postal Address:</strong></p>
            <p style={{ color: 'black' }}>{postalAddress}</p>
            <p style={{ color: 'black' }}><strong>Phone:</strong></p>
            <p style={{ color: 'black' }}>📞 {phone1}<br/>📞 {phone2}</p>
            <p style={{ color: 'black' }}><strong>Email:</strong> 📧 <a href={`mailto:${email}`}>{email}</a></p>
          </div>
        </div>
      </div>
                </div>
                <div className='col-lg-6 d-flex justify-content-center'>
                    <img src={AboutUsSectionImg} className='img-fluid w-75' alt="" />
                </div>
            </div>
        </div>

        <div className='bg-dark text-light py-5'>
            <ChooseSection />
        </div>


<div className='bg-body-tertiary py-5'>
            <div className="container">
                <h2 className='text-center mb-5'style={{ color: 'black' }}><strong>Our Gallery</strong></h2>
                <div className='row g-4'>
                    {persons.map((person) => (
                        <div key={person.id} className='col-md-4'>
                            <img src={person.img} className='img-fluid' alt="" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}



export default ContactUsPage;